export default __webpack_public_path__ + "static/media/regulation.5a1d95c1.svg";